export const HOLIDAY_TYPES = {
  ANNUAL: "ANNUAL",
  ONE_TIME: "ONE_TIME",
} as const;

export type HolidayType = (typeof HOLIDAY_TYPES)[keyof typeof HOLIDAY_TYPES];

export const HOLIDAY_COUNTRY_CODE = "US";

export interface Holiday {
  _id: string;
  name: string;
  countryCode?: string;
  type: HolidayType;
  month?: number;
  day?: number;
  date?: string;
  year?: number;
  active?: boolean;
  source?: string;
  externalKey?: string;
}

export interface HolidayFormValues {
  name: string;
  type: HolidayType;
  month: string;
  day: string;
  date: string;
  active: boolean;
}
